"use client";

import type { ReactNode } from "react";
import React, { useEffect, useRef } from "react";
import type { ButtonProps } from "@/components/Button/Button";
import type { IconButtonProps } from "@/components/Button/IconButton";
import { Button, IconButton } from "../../components/Button";
import Toggle from "../../scripts/modules/Toggle";

type ToggleButtonProps = ButtonProps & {
  children?: ReactNode;
  iconName?: IconButtonProps["iconName"];
};

const ToggleButton: React.FC<ToggleButtonProps> = ({ children, ...other }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const isIconButton = typeof other.iconName === "string";

  useEffect(() => {
    if (buttonRef.current) {
      const button = new Toggle(buttonRef.current);
      return () => {
        button.destroy();
      };
    }
  }, []);

  return isIconButton ? (
    <IconButton ref={buttonRef} {...(other as IconButtonProps)}>
      {children}
    </IconButton>
  ) : (
    <Button ref={buttonRef} {...other}>
      {children}
    </Button>
  );
};

export default ToggleButton;
